import React from "react";
import "./Custom.css";
import CustomTextField from "./CustomTextField";
const TextAreaField = (props) => {
  return (
    <CustomTextField
      fullWidth
      multiline
      rows={4}
      id="message"
      color="black"
      label={props.label}
      value={props.value}
      error={!!props.error}
      placeholder={props.label}
      onChange={(e) => props.setQuestion(e.target.value)}
      slotProps={{
        htmlInput: { maxLength: props.maxLength || 500 },
      }}
    />
  );
};

export default TextAreaField;
